import { createApp } from "vue";
import StudentGroupsManager from "./components/StudentGroupsManager.vue";
import { parseBoolean } from "./utils/parseBoolean";
import { getMountElements, readPayload, VUE_MOUNTED_ATTRIBUTE } from "./utils/vueMount";

const MOUNT_SELECTOR = "[data-vue-student-groups]";

export function initStudentGroupsApp(root = document) {
  const apps = [];

  for (const element of getMountElements(root, MOUNT_SELECTOR)) {
    if (element.hasAttribute(VUE_MOUNTED_ATTRIBUTE)) {
      continue;
    }

    const payload = readPayload(element);
    const app = createApp(StudentGroupsManager, {
      stateUrl: payload.stateUrl || "",
      mutationUrl: payload.mutationUrl || payload.stateUrl || "",
      csrfToken: payload.csrfToken || "",
      canEdit: parseBoolean(payload.canEdit),
      sheetId: Number.parseInt(String(payload.sheetId || "0"), 10) || 0,
      highlightGroupIds: Array.isArray(payload.highlightGroupIds) ? payload.highlightGroupIds : [],
    });

    app.mount(element);
    element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
    apps.push(app);
  }

  return apps;
}
